var _a;
import { Theme } from './front/Theme';
import { SiteHeader } from './modules/SiteHeader/SiteHeader';
import { SharingButtons } from './modules/SharingButtons/SharingButtons';
import { SliderCards } from "./modules/SliderCards/SliderCards";
import { Cta } from './modules/Cta/Cta';
import { InnerContainer } from './modules/InnerContainer/InnerContainer';
import { ImageHotspot } from './modules/ImageHotspot/ImageHotspot';
import { ContactForm } from './modules/ContactForm/ContactForm';
import { ContactFormButton } from './modules/ContactFormButton/ContactFormButton';
import { Products } from './modules/Products/Products';
import { Map } from './modules/Map/Map';
import { SingleProduct } from './layouts/SingleProduct/SingleProduct';
import { Single } from './layouts/Single/Single';
import { SingleArticle } from './layouts/SingleArticle/SingleArticle';
import { Search } from './layouts/Search/Search';
import { onDocumentReady } from './front/lib/utils';
import { FaqEntry } from './modules/FaqEntry/FaqEntry';
import { SiteFooter } from './modules/SiteFooter/SiteFooter';
import { initContactForm7 } from './front/cf7';
import { SliderGallery } from './modules/SliderGallery/SliderGallery';
import { initLanguageSwitcher } from './front/components/LanguageSwitcher/LanguageSwitcher';
import { FailedResponse } from './layouts/FailedResponse/FailedResponse';
if (((_a = document.documentElement.dataset) === null || _a === void 0 ? void 0 : _a.state) !== 'SystemError') {
    onDocumentReady(init);
}
function init() {
    Theme.init({
        modules: {
            SiteHeader,
            SharingButtons,
            SliderCards,
            Cta,
            InnerContainer,
            ImageHotspot,
            Products,
            FaqEntry,
            SiteFooter,
            ContactForm,
            Map,
            ContactFormButton,
            SliderGallery,
        },
        layouts: {
            Search,
            SingleArticle,
            Single,
            SingleProduct,
            FailedResponse,
        },
    });
    initContactForm7();
    initLanguageSwitcher();
    document.documentElement.classList.remove('is--loading');
}
